import { Component, EventEmitter, Input, NgModule, OnInit, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ButtonModule } from 'primeng/button';
import { BtnAuthService } from '../btn-auth.service';

@Component({
  selector: 'auth-button',
  templateUrl: './auth-button.component.html',
  styleUrls: ['./auth-button.component.scss']
})
export class AuthButtonComponent implements OnInit {

  @Input() isButton = true;
  @Input() showDivision = false;
  @Input() buttonId;
  @Input() label: '';
  @Input() icon: '';
  @Input() isLoading: false;
  @Input() badge: 0;
  @Input() isRounded: false;
  @Input() isOutlined: false;
  @Input() isRaised: false;
  @Input() isLink: false;
  @Input() type: 'info';
  @Input() disabled: false;
  @Input() isText: '';
  @Input() buttonClass: '';
  @Output() onClick: EventEmitter<string> = new EventEmitter<string>();

  avaliable = false
  constructor(
    private btnAuth: BtnAuthService
  ) {}

  ngOnInit(): void {
    this.avaliable = this.btnAuth.checkBtnAuth(this.buttonId)
    let classList = []
    classList.push('p-button-sm')

    if (this.isRounded) {
      classList.push('p-button-rounded')
    }
    if (this.isOutlined) {
      classList.push('p-button-outline')
    }
    if (this.isRaised) {
      classList.push('p-button-raised')
    }
    if (this.isLink) {
      classList.push('p-button-link')
    }
    if (this.isText) {
      this.isButton = false;
      classList.push('p-button-text')
    }
  }

  authClick(data?) {
    if (data) {
      this.onClick.emit(data);
    } else {
      this.onClick.emit();
    }
  }

}
@NgModule({
  imports: [ButtonModule, CommonModule],
  exports: [AuthButtonComponent, ButtonModule ],
  declarations: [AuthButtonComponent]
})
export class AuthButtonModule { }
